import { getItem, setItem } from '@bigyellow/libs/storage';
import { useEffect, useState } from 'react';
import { STORE_PAGE } from '@bigyellow/routes';
import { capitalizeFirstLetter } from '@bigyellow/libs/str';
import {
    people_primary__get as business_primary_person_retrieve,
    retrieve as customer_retrieve
} from '@bigyellow/api/customer';
import { setLoggedInFlag } from '@bigyellow/libs/helpers';
import { YOTI_ACCOUNT_HOLDER_URL } from '@bigyellow/api/endpoints';
import getConfig from 'next/config'
const {publicRuntimeConfig} = getConfig();

export const AccountType = {
    DOMESTIC: 'DOM',
    STUDENT: 'STU',
    BUSINESS: 'BUS',
};

/**
 * @deprecated Use AccountType instead.
 */
export const CustomerType = AccountType;

/**
 * @deprecated  Use useCustomer instead.
 * Finds the currently logged in user
 */
export const getCurrentCustomer = async () => {
    return new Promise((resolve, reject) => {
        getItem('user')
            .then((user) => {
                resolve(user);
            })
            .catch(() => {
                reject('No user saved');
            });
    });
};

/**
 * Sets the currently logged in user
 */
export const setCurrentCustomer = async (user) => {
    setLoggedInFlag(!!user?.token)
    return new Promise((resolve, reject) => {
        setItem('user', user)
            .then(() => resolve())
            .catch(() => reject());
    });
};

export const getCustomerType = (user) => {
    let customerType = CustomerType.DOMESTIC;

    if (user && user.customerAccounts && user.customerAccounts.length > 0) {
        const account = user.customerAccounts[0];
        customerType = account.type !== '' ? account.type : customerType;
    }

    return customerType;
};
export const getFirstCustomerAccount = (user) => {
    if (user && user.customerAccounts && user.customerAccounts.length > 0) {
        return user.customerAccounts[0];
    }
    return null;
}
export const getFirstAccountType = (user) => {
    if (user && user.customerAccounts && user.customerAccounts.length > 0) {
        return user.customerAccounts[0].type;
    }
    return CustomerType.DOMESTIC;
}
export  const getAccountById = (user, accountId) => {
    if (user && user.customerAccounts && user.customerAccounts.length > 0) {
        const account = user.customerAccounts.find(account => account.id === accountId);
        return account ? account : null;
    }
    return null;
}

export const getStoreById= ( stores , storeId) => {
    if (stores && stores.length > 0) {
        const store = stores.find(store => store.id === storeId);
        return store ? store : null;
    }
    return null;

}
export const getAccountType = (account) => {
    if (!account || account.type === '') return CustomerType.DOMESTIC;
    return account.type;
};
export  const getAccountId = (account)=>{
    return account.id;
}
export const  getAccountStoreId = (account)=>{
    return account.storeId;
}

// export const getCustomerId = async (user) => {
//
//     // const activeStore = await getItem('activeStore');
//     const activeAccount = await getItem('activeAccount');
//     if (!activeAccount)
//         return 0;
//     const filteredAccount = user.customerAccounts.filter(account => account.id === activeAccount.id);
//
//     return filteredAccount[0].id;
//
// };

/**
 *
 * customer hook .. to get the current customer details
 * @returns {{error: unknown, customer: unknown}}
 */
export const useCustomer = () => {

    const [error, setError] = useState(null);
    const [customer, setCustomer] = useState(null);

    useEffect(() => {
        (async () => {

            try {
                const newCustomer = await getCurrentCustomer();
                setCustomer(newCustomer);
            } catch (e) {
                setError(e);
            }
        })();
    }, []);


    return {customer: customer, error: error};

};
export const useActiveAccount = () => {

      const [error, setError] = useState(null);
      const [activeAccount, setActiveAccount] = useState(null);

      useEffect(() => {
          (async () => {

              try {
                  const newActiveAccount = await getActiveAccount();
                  setActiveAccount(newActiveAccount);
              } catch (e) {
                  setError(e);
              }
          })();
      }, []);
      return {activeAccount: activeAccount, error: error};
}

export const setActiveStore = (item) => {
    return new Promise((resolve, reject) => {
        setItem('activeStore', item)
            .then(() => resolve())
            .catch(() => reject());
    });
}

export const getActiveStore = async () => {
    return new Promise((resolve, reject) => {
        getItem('activeStore')
            .then((item) => {
                resolve(item);
            })
            .catch(() => {
                reject('No active store saved');
            });
    });
};

export const setActiveAccount = (item) => {
    return new Promise((resolve, reject) => {
        setItem('activeAccount', item)
            .then(() => resolve())
            .catch(() => reject());
    });
}

export const getActiveAccount = async () => {
    return new Promise((resolve, reject) => {
        getItem('activeAccount')
            .then((item) => {
                resolve(item);
            })
            .catch(() => {
                reject('No active accounts saved');
            });
    });
};
// export const getActiveAccountId = async () => {
//     const activeAccount = await getActiveAccount();
//     return activeAccount.id;
// }


export const getAccountHolder = async (http_client) => {

    return new Promise(async (resolve, reject) => {
            try {
                let activeAccount = await  getActiveAccount();
                let customerType = getAccountType(activeAccount);
                let accountId = getAccountId(activeAccount);
                const apiRetrieveCall = customerType === CustomerType.BUSINESS ? business_primary_person_retrieve : customer_retrieve;

                const {data: {data: accountHolder}} = await apiRetrieveCall(http_client, {customerId: accountId});
                resolve(accountHolder);
            } catch (error) {
                reject('Failed to retrieve account holder ino');
            }
        }
    );

}


export const getStoreMyAccountUrlByStoreName = (storeName) => {

    if (!storeName) return '';
    return STORE_PAGE.replace('{store_name}', storeName.replace(/\s/g, '-').toLowerCase())


}
export const getYourDetailsUrlByStoreName = (storeName) => {

    if (!storeName) return '';
    return getStoreMyAccountUrlByStoreName(storeName) + "/your-details";


}

export const getStoreNameBySlug = (storeSlug) => {

    let storeName = storeSlug ? storeSlug.replace(/-/g, ' ') : '';
    return storeName
        .trim()
        .split(' ')
        .map((word) => capitalizeFirstLetter(word))
        .join(' ');
}
export const redirectToYotiPage=(customerId)=>{
    window.location.href =  (publicRuntimeConfig.basePath??'')+ YOTI_ACCOUNT_HOLDER_URL.replace('{customerId}', customerId);
}